// extracted by mini-css-extract-plugin
export default {"compareOfferTooltip":"styles_compareOfferTooltip__1DJ8o","tooltipData":"styles_tooltipData__gReUL","fieldTitle":"styles_fieldTitle__bd6V7"};